// Coverage produced by this job. This is where publications are ADDED — a piece
// of coverage comes out of a job, so the job screen is where the files are in hand.
// The client card shows the same records read-only across all of a client's jobs.
//
// Self-fetching rather than riding on the job payload: publications are files and
// metadata, not money, and they must not make the P&L read heavier.
import { useState } from 'react';
import useAsync from '../../hooks/useAsync';
import { publicationsApi } from '../../api';
import he from '../../i18n/he';
import AsyncBoundary from '../../components/Loader';
import Button from '../../components/Button';
import PublicationList from '../../components/PublicationList';
import PublicationModal from '../../components/PublicationModal';

export default function PublicationsPanel({ job }) {
  const { data, loading, error, reload } = useAsync(() => publicationsApi.byJob(job.id), [job.id]);
  const [editing, setEditing] = useState(null); // publication row, {} for new, or null

  const remove = async (row) => {
    if (!window.confirm(he.publications.confirmDelete)) return;
    await publicationsApi.remove(row.id);
    reload();
  };

  return (
    <div className="card w-section">
      <div className="w-head">
        <h2>{he.publications.title}</h2>
        <Button small variant="ghost" onClick={() => setEditing({})}>{he.publications.add}</Button>
      </div>
      <AsyncBoundary loading={loading} error={error}>
        <PublicationList
          publications={data}
          onEdit={(r) => setEditing(r)}
          onDelete={remove}
          empty={{ text: he.publications.emptyList }}
        />
      </AsyncBoundary>
      {editing && (
        <PublicationModal
          jobId={job.id}
          publication={editing}
          onClose={() => setEditing(null)}
          onSaved={() => { setEditing(null); reload(); }}
        />
      )}
    </div>
  );
}
